"use client"

import { Analytics } from "@vercel/analytics/next"
import { SpeedInsights } from "@vercel/speed-insights/next"
import { redactTelemetryEvent } from "@/lib/privacy/secretPaths"

/**
 * Vercel Analytics + Speed Insights con la URL limpia: el link de agenda del
 * socio (/partners/agendar/<token>) lleva una llave en el path y sale como
 * /partners/agendar/[token] (lib/privacy/secretPaths.ts). Componente cliente
 * porque `beforeSend` es una función y el layout raíz es de servidor.
 */
export function VercelTelemetry() {
  return (
    <>
      <Analytics beforeSend={redactTelemetryEvent} />
      <SpeedInsights beforeSend={redactTelemetryEvent} />
    </>
  )
}
